import {
  Col,
  Card,
  Form,
  Button,
  Input,
  CardBody,
  Row,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label
} from 'reactstrap';
import { Tooltip } from "@mui/material";
import { useState, useEffect, useRef } from 'react';
import todoDot from "../../../assets/images/todoDot.png";
import initiatedDot from "../../../assets/images/initiatedDot.png";
import activeDot from "../../../assets/images/activeDot.png";
import closedDot from "../../../assets/images/closedDot.png";
import pendingDot from "../../../assets/images/pendingDot.png";
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import { useNavigate } from 'react-router-dom';
import statusimage from "../../../assets/images/status.png";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import search from "../../../assets/images/search.png";
import calender from "../../../assets/images/calender.png";
import rightarrow from "../../../assets/images/chevron-right.png";
import MoveSanctionStatus from '../MoveSanctionStatus/MoveSanctionStatus';
import download from "../../../assets/images/download.png";
import PaginationTable from '../PaginationTable';
import "./SanctionTable.css";
import axiosInstance from '../../../helpers/axios';
import { useSelector, useDispatch } from "react-redux";
import utr from "../../../assets/images/repayments.png";
import { userActions } from '../../../actions/user.actions';
import { Accordion, AccordionSummary, } from '@mui/material';
import { handleExcelDownload } from '../../../utils/excelDownload';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { IconButton } from '@mui/material';
import { styled } from "@mui/material/styles";
import InstituteAutocomplete from '../../status/ProjectTable/InstituteSearch'
import IntegrationModals from '../../IntegrationModals/IntegrationModals';
import {ApplicationStatusEnum} from '../../../data';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as moment from 'moment';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { appContextConstants } from '../../../constants/appContext.constants';
import EditForm from '../EditForm/EditForm';
import SourceBadge from "../../shared/SourceBadge/SourceBadge";
const CustomAccordionSummary = styled(AccordionSummary)({
  minHeight:50,
  "&.Mui-expanded": {
    minHeight: 40, // Maintain the same height when expanded
  },
  cursor: "default !important", 
  "& .MuiAccordionSummary-content": {
    margin: "0px !important",
    alignItems: "center",
    
  },
});


const CustomAccordion = styled(Accordion)(({ theme }) => ({
  margin: 0, // Remove outer margin
  "&:before": {
    display: "none", // Remove the default divider line
  },
}));

const FILTER_KEY = "sanctionTableFilters";
const getSavedFilters = () => {
  try {
    return JSON.parse(sessionStorage.getItem(FILTER_KEY) || "null") || {};
  } catch {
    return {};
  }
};

const SanctionTable = () => {
  const productTypeSelected = useSelector(
    (state) => state.ProductTypeFilter.selectedProductType
  );
  const saved = getSavedFilters();
  const sanctionstate = useSelector((state) => state?.Insanction?.res);
  const usersearchstate = useSelector((state) => state?.UserSearch?.res?.data?.data);
  const [activePage, setActivePage] = useState(15);

  const dispatch = useDispatch();

  const [cra, newCra] = useState([]);
  const [selectedCRA, setSelectedCRA] = useState('');

  const status = ApplicationStatusEnum.InSanction
  const decode = useCurrentUser();
  const user = null;
  //filter
  const [filterDateFrom, setFilterDateFrom] = useState(saved.filterDateFrom || null);
  const [filterDateTo, setFilterDateTo] = useState(saved.filterDateTo || null);
  const [isLoading, setIsLoading] = useState(true);
  const [id, setId] = useState(saved.instituteId || null)
  const [instituteName, setInstituteName] = useState(saved.instituteName || '');
  const [instituteResetKey, setInstituteResetKey] = useState(0);

   useEffect(() => {
    sessionStorage.setItem(
      FILTER_KEY,
      JSON.stringify({
        filterDateFrom,
        filterDateTo,
        instituteId: id,
        instituteName,
       
      })
    );
  }, [filterDateFrom, filterDateTo, id, instituteName]);
  useEffect(() => {
    window.addEventListener("beforeunload", () => 
      sessionStorage.removeItem("sanctionTableFilters")
    );
  }, []);


  const valid = (current) => {
    return current.isAfter(filterDateFrom);
  };
  //table
  const [tableData, setTableData] = useState([]);
  const [currentPage, setcurrentPage] = useState(sessionStorage.getItem("page") ? parseInt(sessionStorage.getItem("page")) : 1);
  const modalRef = useRef();
  const [rowsPerPage, setrowsPerPage] = useState(15);
  const [totalFetchRows, setTotalFetchRows] = useState(null);
  
  //pagination
  //changepage
  const paginate = (pageNumber) => {
    setcurrentPage(pageNumber)
    setIsLoading(true)
    
  };
  
  
  //sorting

  const urlUsers = `/integrations/applications?status=${status}&perPage=${rowsPerPage}&pageNo=${currentPage}&sortOrder=${-1}`;
  


  useEffect(() => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { status } });
    if(usersearchstate){
      setIsLoading(false);
      setTableData(usersearchstate?.details);
      setcurrentPage(usersearchstate?.pagination.currentPage);
      setTotalFetchRows(usersearchstate?.pagination.totalRows);
      setrowsPerPage(usersearchstate?.pagination.perPage); 
    }else{
      
        let queryParams = {}
    
        if(filterDateFrom && filterDateTo){
          queryParams.fromDate = filterDateFrom;
          queryParams.toDate = filterDateTo+" 23:59:59"
        }
        
        if(id){
          queryParams.instituteId = id
        }
      
        if(status){
          queryParams.status = status
        }
      
        if(selectedCRA){
          queryParams.cra = selectedCRA
        }
        if(rowsPerPage && currentPage){
          queryParams.perPage = rowsPerPage;
          queryParams.pageNo = currentPage
        }
      if (productTypeSelected && productTypeSelected !== "all") {
        queryParams.productType = Number(productTypeSelected);
      }
// END ADD
      axiosInstance.get('/integrations/applications',{
          params:queryParams,
          headers: {
          },
        })
        .then((res)=>{
          setTableData(res?.data?.data?.details);
          setcurrentPage(res?.data?.data?.pagination?.currentPage);
          setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
          setrowsPerPage(res?.data?.data?.pagination?.perPage);
          setIsLoading(false);
        })
        .catch((error) => error)

        }


    // const userUrl = `/admin/users`;
    // axiosInstance.get(userUrl,{
    //   headers: {
    //   },
    // }).then((res)=>{
    //     newCra(res?.data?.data)
    // }).catch((err)=>{
    //
    // })


  }, [usersearchstate, sanctionstate, selectedCRA, filterDateFrom, filterDateTo, id, currentPage, rowsPerPage, productTypeSelected]);


  //datefilter
  const handleDateFilterApi = (startDate, endDate) => {
 
      let queryParams = {}
    
    if(filterDateFrom && filterDateTo){
      queryParams.fromDate = startDate;
      queryParams.toDate = endDate+" 23:59:59"
    }
    
    if(id){
      queryParams.instituteId = id
    }
   
    if(status){
      queryParams.status = status
    }
  
    if(selectedCRA){
      queryParams.cra = selectedCRA
    }
    if(rowsPerPage && currentPage){
      queryParams.perPage = rowsPerPage;
      queryParams.pageNo = 1
    }
    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.productType = Number(productTypeSelected);
    }
// END ADD
    axiosInstance.get('/integrations/applications',{
      params:queryParams,
      headers: {
      },
    })
    .then((res)=>{    
      setTableData(res?.data?.data?.details);
      setcurrentPage(res?.data?.data?.pagination?.currentPage);
      setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
      setrowsPerPage(res?.data?.data?.pagination?.perPage);
        setIsLoading(false);
    })
    .catch((error) => error)
 
  };

    const clearFilters = () => {
    sessionStorage.removeItem(FILTER_KEY);
    sessionStorage.removeItem("page");
    setFilterDateFrom(null);
    setFilterDateTo(null);
    setId(null);
    setInstituteName('');
    setcurrentPage(1);
    setrowsPerPage(15);
    setActivePage(15);
    setIsLoading(true);
  };

  const navigate = useNavigate();

  const handleUser = (event) => {
    const Id = event.userId;
    const applId = event.applicationId;
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      selectedUserId: event?.userId,
      userId: event.userId,
      coapplicantId: event?.coapplicantId ? (typeof event?.coapplicantId == "string") ? event?.coapplicantId : event?.coapplicantId[0] : "",
      appId: applId,
    }});
    // const urlProfile = `/summary/user?id=${Id}&applicationId=${event.applicationId}&status=In Sanction`;

    // dispatch(userActions.fetchHandleuser(urlProfile, user,navigate,applId,Id),[])

//       const ckycUrl=`/ckyc/details?userId=${Id}`;
//   const profileUrl=`/summary/user?id=${Id}&applicationId=${event.applicationId}&status=In Sanction`;
//   const digilockerUrl=`/digilocker/details?applicationId=${event.applicationId}&userId=${Id}`;
//   const panUrl=`/application/pan-details?userId=${Id}&applicationId=${event.applicationId}`;
//   const bankSelfieUrl=`/integrations/details?applicationId=${event.applicationId}&userId=${Id}`;
//   const uploadedFileUrl=`/users/documents/admin?userId=${Id}`
  const getActivityUrl=`/audit?applicationId=${event.applicationId}`
// const urlForBankSelfie=`/integrations/application-profile?applicationId=${event.applicationId}`
//   //cibil
//   const urlCIBIL = `/cibil/report?userId=${Id}`

//   const urlIncomeProfile=`/bank-statement-analysis/finbox/admin-analytics-data/all?userId=${Id}&applicationId=${event.applicationId}`
   
//     dispatch(userActions.getIncomeProfileAnalytics(urlIncomeProfile,user))
    
//    const getFoirRefUrl=`/admin/application/additional-info?applicationId=${event.applicationId}`
//   dispatch(userActions.getFoirDetails(getFoirRefUrl,user));
//         dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie,user),[])
  
//      dispatch(userActions.getCkycDetails(ckycUrl,user));
//     dispatch(userActions.getCibilDetails(urlCIBIL));
//     dispatch(userActions.getPanStatus(panUrl));
//     dispatch(userActions.getBankSelfieDetails(bankSelfieUrl,user));
//     dispatch(userActions.getDigiLocker(digilockerUrl,user));
//     dispatch(userActions.getProfileDetails(profileUrl));
//     dispatch(userActions.getUploadedFiles(uploadedFileUrl,user));
    dispatch(userActions.getActivity(getActivityUrl,user));
    navigate('/status/sanction/profile', {
      state: { id: 1, profileId: Id,applicantId:event.userId,coapplicantId:event.coapplicantId,applicationId:event.applicationId,dir:"In Sanction", coapplicants: event?.coapplicants, name: event?.name, digilockerStatus: event?.digilockerStatus, selfie: event?.selfie, agreement: event?.agreement, emandate: event?.emandate, applicantFraudCheck: event?.applicantFraudCheck },
    });

   
  };

 


  const handleCoApp = (event, coAppUserId) => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { selectedUserId: coAppUserId } });
    const Id =(event?.coapplicants?.length > 1)? coAppUserId:  event?.coapplicantId ? (typeof event?.coapplicantId == "string")?event?.coapplicantId:event?.coapplicantId[0]:"";
    const applId = event.applicationId

    const urlProfile = `/summary/coapplicant?id=${Id}&status=In Sanction`;
   
//     dispatch(userActions.fetchHandlcoappuser(urlProfile, user,navigate,applId,Id),[])

//       const ckycUrl=`/ckyc/details?userId=${Id}`;
//   const profileUrl=`/summary/coapplicant?id=${Id}&status=In Sanction`;
//   const digilockerUrl=`/digilocker/details?applicationId=${event.applicationId}&userId=${Id}`;
//   const panUrl=`/application/pan-details?userId=${Id}&applicationId=${event.applicationId}`;
//   const bankSelfieUrl=`/integrations/details?applicationId=${event.applicationId}&userId=${Id}`;
//   const uploadedFileUrl=`/users/documents/admin?userId=${Id}`
  const getActivityUrl=`/audit?applicationId=${event.applicationId}`
// const urlForBankSelfie=`/integrations/application-profile?applicationId=${event.applicationId}`
//   //cibil
//   const urlCIBIL = `/cibil/report?userId=${Id}`

// const urlIncomeProfile=`/bank-statement-analysis/finbox/admin-analytics-data/all?userId=${Id}&applicationId=${event.applicationId}`
   
//     dispatch(userActions.getIncomeProfileAnalytics(urlIncomeProfile,user))
    
//    const getFoirRefUrl=`/admin/application/additional-info?applicationId=${event.applicationId}`
//   dispatch(userActions.getFoirDetails(getFoirRefUrl,user));
//         dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie,user),[])
  
//      dispatch(userActions.getCkycDetails(ckycUrl,user));
//     dispatch(userActions.getCibilDetails(urlCIBIL));
//     dispatch(userActions.getPanStatus(panUrl));
//     dispatch(userActions.getBankSelfieDetails(bankSelfieUrl,user));
//     dispatch(userActions.getDigiLocker(digilockerUrl,user));
//     dispatch(userActions.getProfileDetails(profileUrl));
//     dispatch(userActions.getUploadedFiles(uploadedFileUrl,user));
    dispatch(userActions.getActivity(getActivityUrl,user));
    navigate('/status/sanction/profile', {
      state: { id: 1, profileId: Id,clickEvent:"coapp",applicantId:event.userId,coapplicantId:event.coapplicantId,applicationId:event.applicationId,dir:"In Sanction", coapplicants: event?.coapplicants, name: event?.name, digilockerStatus: event?.digilockerStatus, selfie: event?.selfie, agreement: event?.agreement, emandate: event?.emandate, applicantFraudCheck: event?.applicantFraudCheck },
    });
     
   
  };

  //Go To Application Profile
   const handleApplicationProfile=(currApplicationId,currUID,currCoAppId, item)=>{
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      userId: currUID,
      appId: currApplicationId,
      coappId: currCoAppId,
    }});
    // const urlForApplicationDetails=`/admin/application/application-profile?applicationId=${sessionStorage.getItem("appId")}`
    // const urlForBankSelfie=`/integrations/application-profile?applicationId=${sessionStorage.getItem("appId")}`
    // const getEmiUrl=`/emis?applicationId=${sessionStorage.getItem("appId")}`
    // const getActivityUrl=`/audit?applicationId=${sessionStorage.getItem("appId")}`
    // dispatch(userActions.fetchUrlforApplicationdetails(urlForApplicationDetails,user),[])
    // dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie,user),[])
    // dispatch(userActions.fetchEmiUrl(getEmiUrl,user),[])
    // dispatch(userActions.getActivity(getActivityUrl,user))
    navigate("/status/sanction/appProfile", {state: item})
    
  }
  
  const handleDownloadList = () => {
    handleExcelDownload({
      status: status,
      instituteId: decode.instituteId ? decode.instituteId : id,
      fromDate: filterDateFrom,
      toDate: filterDateTo,
      productType:
        productTypeSelected && productTypeSelected !== "all"
          ? Number(productTypeSelected)
          : undefined,
      user: user,
      downloadIcon: download,
      buttonId: 'downloadButton',
      buttonStyles: {
        width: '90px',
        marginLeft: '150px'
      }
    });
  }   


  
  const getInsituteInfo=(text)=>{
    
    const urlGetInstitute=`/institute/info/name?name=${text}`;
      
    if(text.length>=4)
    {
      axiosInstance.get(urlGetInstitute,{
        headers:{
        }
      }).then((res) => {
        setId(res?.data?.data[0]?.id)
        handleInputChange(res?.data?.data[0]?.id)
      });
  
   
    }
 
  }
  const handlepageChange = (number) => {
    setIsLoading(true)
    setActivePage(number)
    setrowsPerPage(number);

    let queryParams = {}
    
    if(filterDateFrom && filterDateTo){
      queryParams.fromDueDate = filterDateFrom;
      queryParams.toDate = filterDateTo+" 23:59:59"
    }
    
    if(id){
      queryParams.instituteId = id
    }
   
    if(status){
      queryParams.status = status
    }
  
    if(selectedCRA){
      queryParams.cra = selectedCRA
    }
    if(rowsPerPage && currentPage){
      queryParams.perPage = number;
      queryParams.pageNo = 1
    }
    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.productType = Number(productTypeSelected);
    }
// END ADD
    axiosInstance.get('/integrations/applications',{
      params:queryParams,
      headers: {
      },
    })
    .then((res)=>{    
      setTableData(res?.data?.data?.details);
      setcurrentPage(res?.data?.data?.pagination?.currentPage);
      setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
      setrowsPerPage(res?.data?.data?.pagination?.perPage);
        setIsLoading(false);
    })
    .catch((error) => error)   
};



  const handleInputChange = (id) => {
    setIsLoading(true)
    let queryParams = {}
    
    if(filterDateFrom && filterDateTo){
      queryParams.fromDate = filterDateFrom;
      queryParams.toDate = filterDateTo+" 23:59:59"
    }
    
    if(id){
      queryParams.instituteId = id
    }
   
    if(status){
      queryParams.status = status
    }
  
    if(selectedCRA){
      queryParams.cra = selectedCRA
    }
    if(rowsPerPage && currentPage){
      queryParams.perPage = rowsPerPage;
      queryParams.pageNo = 1
    }
    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.productType = Number(productTypeSelected);
    }
// END ADD
    axiosInstance.get('/integrations/applications',{
      params:queryParams,
      headers: {
      },
    })
    .then((res)=>{    
      setTableData(res?.data?.data?.details);
      setcurrentPage(res?.data?.data?.pagination?.currentPage);
      setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
      setrowsPerPage(res?.data?.data?.pagination?.perPage);
      setIsLoading(false);
    })
    .catch((error) => error)   
};

  
function formatNumberWithCommas(number) {
  return number.toLocaleString('en-IN'); 
}
  const [paymentModal, setPaymentModal] = useState(false);
  const [advEmiChecked,setAdvEmiChecked] = useState(true)
  const [pfChecked,setPfChecked] = useState(true)
  const [paidAtInstChecked,setPaidAtInstChecked] = useState(false)
  const [pf,setPf] = useState(null)
  const [adv,setAdv] = useState(null)
  const [userId,setUserId] = useState(null)
  const [appId,setAppId] = useState(null)
  const [instName,setInstName] = useState(null)
  const [expanded, setExpanded] = useState(null);


  const togglePayment = (item) => {
    if (!paymentModal) {
      setAdvEmiChecked(true);
      setPfChecked(true);
      setPf(null);
      setAdv(null);
      setUserId(null);
      setAppId(null);
      setPaidAtInstChecked(false)
    }
      setUserId(item?.userId)
      setAppId(item?.applicationId)
      setInstName(item?.instituteName)
      setPf(item?.processingFee)
      setAdv(item?.advanceEmi)
      setPaymentModal(!paymentModal);
  }
  const [clicked, setClicked] = useState(false);

  const GenerateLink = () =>{
    setClicked(true);
    const data = {
      userId:userId,
      applicationId:appId,
      advEmi:advEmiChecked?adv:0,
      processingFee:pfChecked?pf:0,
      totalAmount:(advEmiChecked ? parseFloat(adv) : 0) + (pfChecked ? parseFloat(pf) : 0),
      instituteName:instName,
      status: paidAtInstChecked ? 5 : (pf === 0 && adv === 0 ? 4 : 0)
    };
    const createUrl = `/pre-disbursement-collection/create-link`;

    axiosInstance.post(createUrl,data,{
      headers:{
    }
    }).then((res)=>{
      if(res?.data?.message === "Successful"){
        alert('Link Generated Successfully')
        setClicked(false)
        setPaymentModal(!paymentModal);
        setTimeout(() => {
          window.location.reload()
      }, 500);
      }
    }).catch((error)=>{
    alert(error?.response?.data?.message)
  setClicked(false)})
  }
  const [manualUpdateModal,setManualUpdateModal] = useState(false);

  const toggleManualUpdateModal = () => setManualUpdateModal(!manualUpdateModal);

  const [utrNumber,setUtrNumber] = useState("")
  const [paidDate,setPaidDate] = useState("")
  const [advanceEmi,setAdvanceEmi] = useState(null)
  const [manualPf,setManualPf] = useState(null)
  const [remarks,setRemarks] = useState("")

  const CreateManualPayment = () =>{
    setClicked(true);
    const data = {
      userId:userId,
      applicationId:appId,
      advEmi:advanceEmi?advanceEmi:adv,
      processingFee:manualPf?manualPf:pf,
      totalAmount: (parseFloat(advanceEmi ? advanceEmi : adv) + parseFloat(manualPf ? manualPf : pf)),
      instituteName:instName,
      status:3,
      utr:utrNumber,
      mode:2,
      paidDate:paidDate
    };

    const createUrl = `/pre-disbursement-collection/create-manual-payment`;

    axiosInstance.post(createUrl,data,{
      headers:{
    }
    }).then((res)=>{
      if(res?.data?.message === "Successful"){
        alert('UpdatedSuccessfully')
        setClicked(false)
        setManualUpdateModal(!manualUpdateModal);
        setTimeout(() => {
          window.location.reload()
      }, 500);
      }
    }).catch((error)=>{
    alert(error?.response?.data?.message)
  setClicked(false)})
  }

  const handleToggle = (applicationId) => {
    setExpanded((prev) => prev===applicationId? null : applicationId);
  };

  const refreshTableData = () => {
    axiosInstance.get(urlUsers, {
    }).then((resp) => {
      setTableData(resp.data.data.details);
      setcurrentPage(resp.data.data.pagination.currentPage);
      setTotalFetchRows(resp.data.data.pagination.totalRows);
      setrowsPerPage(resp.data.data.pagination.perPage);
    });
  };

  if (tableData) {
    return (
      
      <Card className="card" style={{ width:"100%",height:'100%'}}>
        <CardBody>
        <div>
          <p style={{display:'flex',alignItems:'center'}}><img src={statusimage} alt=""/><span style={{fontFamily:'Inter-Medium',marginLeft:'10px',fontSize:'14px'}}>status</span><span style={{marginLeft:'20px',marginBottom:'3px'}}> <img style={{height:"18px",width:"14px"}} src={rightarrow} alt=""/></span><span style={{fontFamily:'Inter-Medium',marginLeft:'10px',fontSize:'14px',color:'#D32028'}}>{status}</span></p>
          
         </div>
          <Row>
          <div style={{ display: 'flex', flex: 'wrap'}}>
          <Col sm="12" md="10" lg="3">
            <div style={{ height: '23px', marginRight: '10px',fontFamily:'Inter'  , position: 'relative', display: 'flex', alignItems: 'center' }}>
            {decode.role === "institute_admin" || decode.role === "institute_user" || decode.role === "institute_cra" ?
            <Input
            type="text"
            id="userSearch"
            value={decode.instituteName}
            readOnly
            disabled
            placeholder={'Merchant Name'
            }
            style={{
               fontSize: '0.8vw',
              paddingLeft: '26px',
              fontFamily: 'Inter',
              backgroundImage: `url(${search})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '5px center',
              backgroundSize: '15px 15px',
              paddingRight: '5px', 
              borderColor:'#cccccc',
              borderStyle:'solid',
              borderRadius:"5px",
              borderWidth:'1px',
              height:'34px',
              marginTop:'11px'
            }}
          />: 
        //   <Input
        //   type="text"
        //   id="userSearch"
        //   placeholder={ decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? 'Product Type': 'Merchant Name'}
        //   onChange={(event) => {
        //     getInsituteInfo(event.target.value);
        //   }}
        //   style={{
        //      fontSize: '0.8vw',
        //     paddingLeft: '26px',
        //     fontFamily: 'Inter',
        //     backgroundImage: `url(${search})`,
        //     backgroundRepeat: 'no-repeat',
        //     backgroundPosition: '5px center',
        //     backgroundSize: '15px 15px',
        //     paddingRight: '5px', 
        //     borderColor:'#cccccc',
        //     borderStyle:'solid',
        //     borderRadius:"5px",
        //     borderWidth:'1px',
        //     height:'34px',
        //     marginTop:'11px'
        //   }}
        // />
         
            <InstituteAutocomplete
              key={instituteResetKey}
              onInstituteSelect={(selectedId,name) => {
                setId(selectedId)
                setInstituteName(name || '');
              }} 
              defaultValue={instituteName} 
              searchIcon={search}
                placeholder={
                decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                  ? 'Product Type'
                  : 'Merchant Name'
              }
            /> 
          }
          </div>
            </Col>
            <Col>
              <div style={{ height: '7px', marginRight: '10px', marginLeft:'12px' }}>
                <Datetime
                closeOnSelect="false"
                  id="fromDate"
                  dateFormat="DD MMM YYYY"
                  timeFormat={false}
                  onChange={(event) =>{ 
                    if (event && event.format) {
                    setFilterDateFrom(event.format('DD MMM YYYY'));
                  }else{
                    setFilterDateFrom(null);
                  }
                  }}
                  locale="en-gb"
                  inputProps={{ placeholder: 'From Date',style:{fontFamily:'Inter',fontSize:"14px"} }}
                />
              </div>
            </Col>
            <Col>
              <div style={{ height: '7px', marginRight: '10px' }}>
                <Datetime
                closeOnSelect="false"
                  id="toDate"
                  key={filterDateFrom}  
                  dateFormat="DD MMM YYYY"
                  isValidDate={valid}
                  timeFormat={false}
                  locale="en-gb"
                  initialViewDate={
                        filterDateFrom
                          ? moment(filterDateFrom, 'DD MMM YYYY')
                          : moment()
                  }
                  onChange={(event) => {
                    if (event && event.format) {
                      setFilterDateTo(event.format('DD MMM YYYY'));
                    } else {
                      setFilterDateTo(null); 
                    }
                  }}
                  value={filterDateTo}
                  inputProps={{ placeholder: 'To Date',style:{fontFamily:'Inter',fontSize:"14px"} }}
                />
              </div>
            </Col>
            <Col>
            <div> 
            <button style={{display: 'flex', alignItems: 'center',width:'130px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter",paddingLeft:'10px'}}
                onClick={() =>{ handleInputChange(id)}}
              >
                Search Results
              </button>
              </div>
            </Col>
             <Col>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  <button
                                    onClick={() => {
                                      clearFilters();
                                      setInstituteResetKey((prev) => prev + 1);
                                    }}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      height: '34px',
                                      width: '42px',
                                      backgroundColor: '#D22129',
                                      border: 'none',
                                      borderRadius: '5px',
                                      color: 'white',
                                      cursor: 'pointer',
                                      marginLeft:'10px'
                                   
                                    }}
                                  >
                                    <RefreshIcon />
                                  </button>
                                </div>
                              </Col>

            {decode.role === "institute_admin" || decode.role === "institute_user" || decode.role === "channel_user" ? null :(
            <Col>
            <div>
            {/* <Input type="select" name="select" id="exampleSelect" value={selectedCRA} onChange={(e) => setSelectedCRA(e.target.value)}>
            <option value="">Select CRA</option> 
            {cra?.map((item,index)=>(
              <option>{item.emailId}</option>
            ))}
            </Input> */}
            </div>
            </Col>
            )}
           
            {(decode.role === "cra" || decode.role === "crsa" || decode.role === "institute_cra" ||
  (decode.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e" && decode.role === "institute_user"))?"":(
              <Col>
            <button style={{backgroundColor:'#D22129',width:'90px',height:'34px',padding:'10px',display: 'flex', alignItems: 'center',marginLeft:"150px",borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter"}} id="downloadButton" onClick={() => handleDownloadList()}>
           <p style={{display:'flex',alignItems:'center',marginTop:'15px'}}><img style={{height:'15px',alignItems:"center",marginRight:'5px'}}  src={download} alt="download"/><span>Export</span></p> 
            </button>
            </Col>
            )}
            
          </div>
        </Row>
        <Modal isOpen={paymentModal}  >
        <ModalHeader toggle={togglePayment}>Payment Link</ModalHeader>
        <ModalBody>
        <Form> 
        <div>
          <FormGroup
            check
            inline
          >
            <Input type="checkbox"  style={{marginTop:'12px'}} onChange={() => setPaidAtInstChecked(!paidAtInstChecked)} checked={paidAtInstChecked}/>
            <Label check style={{marginLeft:'10px'}}>
              Paid At Institute
            </Label>
          </FormGroup>
          </div>
          <div style={{display:'flex',alignItems:'center'}}>
          <FormGroup
            check
            inline
          >
            <Input type="checkbox" style={{marginTop:'12px'}} onChange={() => setAdvEmiChecked(!advEmiChecked)} checked={advEmiChecked} disabled={paidAtInstChecked}/>
            <Label check>
            Adv Emi  
            </Label>
          </FormGroup>
          <FormGroup  style={{marginLeft:'0.9rem'}}
          >
                                  
            <Input type="text" placeholder='Adv Emi' style={{marginTop:'12px'}} value={advEmiChecked?adv:null} disabled={paidAtInstChecked}/>

          </FormGroup>
          </div>
          <div style={{display:'flex',alignItems:'center'}}>
          <FormGroup
            check
            inline
          >
            <Input type="checkbox"  style={{marginTop:'12px'}} onChange={() => setPfChecked(!pfChecked)} checked={pfChecked} disabled={paidAtInstChecked}/>
            <Label check style={{marginLeft:'10px'}}>
              Pf
            </Label>
          </FormGroup>
          <FormGroup
            style={{marginLeft:'3rem'}}
            
          >
            <Input type="text"placeholder='pf' style={{marginTop:'12px'}} defaultValue={pfChecked?pf:null} disabled={paidAtInstChecked}/>
            
          </FormGroup>
          </div>
          <div style={{display:'flex',alignItems:'center'}}>
            <Label>Adv + pf : </Label>
            <FormGroup
            style={{marginLeft:'2.6rem'}}
            
          >
            <Input type="text" style={{marginTop:'12px'}}  value={(advEmiChecked ? parseFloat(adv) : 0) + (pfChecked ? parseFloat(pf) : 0)} disabled={paidAtInstChecked}/>
            
          </FormGroup>
          </div>
          
        </Form>
        </ModalBody>
        <ModalFooter style={{display:'flex',justifyContent:'space-between'}}>
          <Button  style={{backgroundColor:'#D32028',color:'white',border:'none',transform: clicked ? 'scale(1.1)' : 'none',
        transition: 'transform 0.3s ease',}} onClick={GenerateLink}>
            Generate Link
          </Button>{' '}
          <Button  style={{backgroundColor:'#D32028',color:'white',border:'none',transform: clicked ? 'scale(1.1)' : 'none',
        transition: 'transform 0.3s ease',}} onClick={toggleManualUpdateModal}>
            Update Manual Pmt.
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={manualUpdateModal} toggle={toggleManualUpdateModal}>
        <ModalHeader toggle={toggleManualUpdateModal}>Manual Update Payment</ModalHeader>
        <ModalBody>
        <p style={{fontSize:'14px',fontFamily:'Inter-Medium',lineHeight:'1em'}}>UTR</p>
           <Input  style={{fontSize:'14px',color:'#667085',fontFamily:'Inter-Medium'}}  placeholder='Enter UTR' defaultValue={utrNumber} onChange={(e)=>setUtrNumber(e.target.value)}>
          
          </Input>
        <p style={{fontSize:'14px',fontFamily:'Inter-Medium',lineHeight:'1em',marginTop:'3vh'}}>Paid Date</p>
        <Datetime
                closeOnSelect="false"
                  id="fromDate"
                  dateFormat="DD MMM YYYY"
                  timeFormat={false}
                  onChange={(event) => {
                      setPaidDate(event.format('DD MMM YYYY'));
                    
                  }}
                  locale="en-gb"
                  inputProps={{ placeholder: 'Select Paid Date',style:{fontFamily:'Inter-Medium', backgroundImage: `url(${calender})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '5px center',
                  backgroundSize: '15px 15px', paddingLeft: '30px',fontSize:"14px"} }}                />
           
          <p style={{fontSize:'14px',fontFamily:'Inter-Medium',lineHeight:'1em',marginTop:'3vh'}}>Advance Emi</p>
           <Input  style={{fontSize:'14px',color:'#667085',fontFamily:'Inter-Medium'}} placeholder='Enter Advance Emi' defaultValue={adv} onChange={(e)=>setAdvanceEmi(e.target.value)}>
          
          </Input>
          <p style={{fontSize:'14px',fontFamily:'Inter-Medium',lineHeight:'1em',marginTop:'3vh'}}>Processing Fee</p>
           <Input  style={{fontSize:'14px',color:'#667085',fontFamily:'Inter-Medium'}} placeholder='Enter Processing Fee' defaultValue={pf} onChange={(e)=>setManualPf(e.target.value)}>
          
          </Input>
          <p style={{fontSize:'14px',fontFamily:'Inter-Medium',lineHeight:'1em',marginTop:'3vh'}}>Remarks</p>
           <Input  style={{fontSize:'14px',color:'#667085',fontFamily:'Inter-Medium'}} placeholder='Enter Remarks' defaultValue={remarks} onChange={(e)=>setRemarks(e.target.value)}>
          
          </Input>
        </ModalBody>

        <div style={{display:'flex',alignItems:'center',justifyContent:'center',marginBottom:'10px'}}>
            <button style={{paddingLeft:'10px',fontFamily:'Inter-medium',color:'white',backgroundColor:'#D32028',paddingRight:'10px',borderRadius:'6px',transform: clicked ? 'scale(1.1)' : 'none',
        transition: 'transform 0.3s ease'}} onClick={CreateManualPayment}>Update</button>
          </div>
      </Modal>
        {isLoading ? (
          <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%',backgroundColor:'white',height:'100vh'}}>
          <CircularProgress />
        </Box>
        ):(
          <>
          <div className='tables' style={{ marginTop: '20px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', borderSpacing: 0 }}>
            <thead className='table-heading'>
                <tr>
                  <th style={{ fontSize: '15px',borderTopLeftRadius:'8px', width: '12%', padding:'10px'}} id="appId">
                    <span style={{fontFamily:'Inter',fontSize:'14px',marginLeft:'10px'}}>Appl. Id</span>
                  </th>
                  <th  id="appname" style={{width:'15%'}}><span style={{fontFamily:'Inter',fontSize:'14px',marginLeft:'10px'}}>Appl. Name</span></th>
                  {(decode.role==="institute_user"||decode.role==="institute_admin"|| decode.role === "channel_user" ) && decode.instituteId === "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" ? 
                   <th  style={{  fontSize: '14px',fontFamily:"Inter", }} id="appname">
                   <span style={{marginLeft:'10px',whiteSpace:'nowrap'}}></span> Student Name
                   </th>:null
                  }
                  <th  id="insName"style={{width:'14%'}}><span style={{fontFamily:'Inter',fontSize:'14px',marginLeft:'10px',whiteSpace:'nowrap'}}>{ decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? 'Product Type': 'Merchant Name'}</span></th>
                  <th  id="digiLocker"style={{width:'8%'}}><span style={{marginLeft:'7px',fontFamily:'Inter',fontSize:'14px'}}>DigiLocker</span></th>
                  <th  id="selfie"style={{width:'8%'}}><span style={{marginLeft:'7px',fontFamily:'Inter',fontSize:'14px'}}>Selfie</span></th>
                  <th  id="agreement"style={{width:'8%'}}><span style={{marginLeft:'7px',fontFamily:'Inter',fontSize:'14px'}}>Agreement</span></th>
                  <th  id="eMandate"style={{width:'8%'}}><span style={{marginLeft:'7px',fontFamily:'Inter',fontSize:'14px'}}>EMandate</span></th>
                 {decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"  || decode.role === "channel_user"?null: <th  style={{width:'4%', paddingLeft:'7px'}}><span style={{fontFamily:'Inter',fontSize:'14px'}}>Frd.</span></th>}
                  <th  id="amt"style={{marginLeft:'18px',fontFamily:'Inter',fontSize:'14px', width:'8%'}}><span style={{marginLeft:'10px'}}></span>Amount</th>
                  <th  id="tenure"style={{width:'5%', paddingLeft:'7px'}}><span style={{fontFamily:'Inter',fontSize:'14px', }}>Tenure</span></th>
                 {decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"  || decode.role === "channel_user"? null :   
                  <th  id="pmt"style={{width:'3%', paddingLeft:'5px'}}><span style={{fontFamily:'Inter',fontSize:'14px',display:'flex',flexWrap:'nowrap',}}>Pmt.</span></th>
                  }
                  { decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"  || decode.role === "channel_user"?null:
                    <th id="actions"  style={{width:'3em', }}><span style={{marginLeft:'10px',fontFamily:'Inter',fontSize:'14px',borderTopRightRadius:'8px'}}>Actions</span></th>
                  }
                </tr>
              </thead>
              <tbody>
              {tableData.map((item, index) => {
                return (
                  <tr key={index}>
                    <td colSpan="100%" style={{ padding: 0}}>
                      <CustomAccordion  style={{width: '100%', padding:0, cursor:'default !important'}} expanded={item?.coapplicants?.length===1 ? true: expanded=== item?.applicationId}>
                        <CustomAccordionSummary sx={{ width: '100%', margin: 0, padding: 0 , display:'flex',flexDirection:'row', alignItems: 'center'}}
                           
                        >
                          {/* Appl. Id */}
                          <td style={{width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '14%':'12%', display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}} >
                          <Tooltip title={(decode.role==="institute_user" && decode.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e")?item.studentId:item.applicationId} arrow>
                            <span className='application-id-span'
                            style={{
                   color: '#667085',       
                   lineHeight: '1.4em'     
                     }}
                              onClick={()=>{
                              if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return
                              handleApplicationProfile(item.applicationId,item.userId,item.coapplicantId, item)
                              }} >
                               { item?.applicationId}
                            </span>
                            </Tooltip>
                           {item?.coapplicants?.length > 1 &&  <IconButton
                                onClick={() => handleToggle(item?.applicationId)} 
                              >
                                {expanded === item?.applicationId ? <ExpandLessIcon />: <ExpandMoreIcon/>}
                            </IconButton>
                            }
                          </td>
                       
                          <td title={item.name}
                           onClick={() =>{
                            if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return
                            handleUser(item)
                          } } className='application-id'  style={{width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '17.5%':'15%', cursor:'pointer' ,lineHeight: '1.4em',color: '#667085' }}>{item?.name?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</td>
                          {(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")&&decode.instituteId === "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" &&
                           <td title={item.studentName} lassName='application-id'>{item.studentName ? item.studentName : "-"}</td>
                           }
                           {/* MerchantName */}
                          <td style={{width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '16.5%': '14%'}}>
                            <span style={{display:'flex', justifyContent:'space-between', paddingRight:'7px',}}>
                            <span className="merchant-with-source">
                            <span
                            title={item.instituteName}
                            className='application-id'
                            style={{
        color: '#667085',
        lineHeight: '1.4em'
      }}
                            >{item.instituteName?item.instituteName:'-'}</span>
                            {item.productType === 2 && (
                              <SourceBadge attribution={item.attribution} repeat={item.repeat} />
                            )}
                            </span>
                            {(decode.role==="institute_user" && decode.instituteId !== "9d5eca4b-54f7-42a7-8794-1413e00b462e") ||decode.role==="institute_admin" || decode.role === "channel_user" ? null:(
                            <span style={{display:'flex', alignItems:'center', }}>{item.approvalType?(
                              item.approvalType === 1? (
                                <span title='Automatic' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'25px',width:'25px',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',fontWeight:'bold',padding:'5px',cursor:'pointer',color:'black',lineHeight:'1rem'}} >A</span>
                              ) : item.approvalType === 2 ? (
                                <span title='Manual' style={{fontSize:'12px',backgroundColor:'#F8A31F', borderStyle:'solid',borderRadius:'50%',border:'none',height:'25px',width:'25px',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',fontWeight:'bold',padding:'5px',cursor:'pointer',color:'black',lineHeight:'1rem'}} >M</span>
                              ) :item.approvalType === 3 ? (
                                <span title='Exception' style={{fontSize:'12px',backgroundColor:'#FEEAEB',borderStyle:'solid',borderRadius:'50%',border:'none',height:'25px',width:'25px',display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',fontWeight:'bold',padding:'5px',cursor:'pointer',color:'#D22129',lineHeight:'1rem'}} >E</span>
                              ):
                              item.approvalType
                            ):""
                            } </span>
                            )}
                           </span>

                          </td>
                          {/* Digilocker */}
                          <td style={{ width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '10%': '8%', paddingLeft:'7px'}}>
                            <span key={item.userId}  id="selfie" onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin"|| decode.role === "channel_user" || decode.role === "exec") return; modalRef.current.open('digilocker', {applicationId: item.applicationId, userId: item.userId, name: item.name, status: item.digilockerStatus})}}
                                style={{ cursor:decode.role === "exec"? 'default': 'pointer', fontWeight:'600',fontSize: '12px', padding: '3px 5px 3px 5px',
                                backgroundColor:`${item.digilockerStatus==='Pass'?'#ECFDF3':`${item.digilockerStatus==='Not Initiated'?'#898989':`${item.digilockerStatus==='Failed'?'#FEEAEB':`${item.digilockerStatus==='Initiated'?'#EFE4FF':`${item.digilockerStatus==='Alert'?"#FFF6E8":''}`}`}`}`}`,
                                color:`${item.digilockerStatus==='Pass'?'#12B76A':`${item.digilockerStatus==='Not Initiated'?'white':`${item.digilockerStatus==='Failed'?'red':`${item.digilockerStatus==='Initiated'?'#6E24E7':`${item.digilockerStatus==='Alert'?"#F8A31F":''}`}`}`}`}`,
                                  textAlign:'center',borderRadius:'1em'}}> 
                                {item.digilockerStatus?(item.digilockerStatus==="Pass"?<span><img src={activeDot} alt="" /> Pass</span>:item.digilockerStatus==="Failed"?<span><img src={closedDot} alt=""/> Failed</span>:item.digilockerStatus==="Not Initiated"?<span><img src={todoDot} alt=""/> To Do</span>:item.digilockerStatus==="Initiated"?<span><img src={initiatedDot} alt=""/> Initiated</span>:item.digilockerStatus==="Alert"?<span><img src={pendingDot} alt=""/> Attn!</span>:item.digilockerStatus):"NA"}
            
                            </span>
                          </td> 
                          {/* Selfie */}
                          <td style={{ width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '8.9%':'8%', paddingLeft:'7px'}}>
                            <span key={item.userId}  id="selfie" onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin"|| decode.role === "channel_user" || decode.role === "exec") return; modalRef.current.open('selfie', {applicationId: item.applicationId, userId: item.userId, name: item.name})}}
                                style={{ cursor:decode.role === "exec"? 'default': 'pointer', fontWeight:'600',fontSize: '12px', padding: '3px 5px 3px 5px',
                                backgroundColor:`${item.selfie==='Pass'?'#ECFDF3':`${item.selfie==='Not Initiated'?'#898989':`${item.selfie==='Failed'?'#FEEAEB':`${item.selfie==='Initiated'?'#EFE4FF':`${item.selfie==='Face mismatch'?"#FFF6E8":''}`}`}`}`}`,
                                color:`${item.selfie==='Pass'?'#12B76A':`${item.selfie==='Not Initiated'?'white':`${item.selfie==='Failed'?'red':`${item.selfie==='Initiated'?'#6E24E7':`${item.selfie==='Face mismatch'?"#F8A31F":''}`}`}`}`}`,
                                  textAlign:'center',borderRadius:'1em'}}> 
                                {item.selfie?(item.selfie==="Pass"?<span><img src={activeDot} alt=""/> Pass</span>:item.selfie==="Failed"?<span><img src={closedDot} alt=""/> Failed</span>:item.selfie==="Not Initiated"?<span><img src={todoDot} alt=""/> To Do</span>:item.selfie==="Initiated"?<span><img src={initiatedDot} alt=""/> Initiated</span>:item.selfie==="Face mismatch"?<span><img src={pendingDot} alt=""/> Attn!</span>:item.selfie):"NA"}
            
                            </span>
                          </td>
                          {/* Aggrement */}
                          <td style={{  width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '8.9%': '8%', paddingLeft:'7px'}}>
                            <span onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" || decode.role === "exec") return; modalRef.current.open('agreement', {applicationId: item.applicationId, userId: item.userId, name: item.name, status: item.agreement})}} id="signed"
                              style={{cursor:decode.role === "exec"? 'default': 'pointer',fontSize: '12px',  fontFamily:"Inter",fontWeight:'600',  padding: '3px 5px 3px 5px',
                                backgroundColor:item.agreement==='Signed'||item.agreement==='Manual'?'#ECFDF3':item.agreement==="Regenerated"?'#00AD83':item.agreement==='Not Initiated'?'#898989':item.agreement==='Pending'?'#FFF6E8':item.agreement==='Initiated'?'#EFE4FF':item.agreement==='Invalid'?'#FFF6E8':item.agreement==="Pending Coapplicant"?"#FFF6E8":'',textDecoration:item.agreement==='Signed'||item.agreement==='Manual'?'underline':'none',
                                color:item.agreement==='Signed'||item.agreement==='Manual'?'#12B76A':item.agreement==="Regenerated"?'white':item.agreement==="Pending Coapplicant"?'#F8A31F':item.agreement==='Not Initiated'?'white':item.agreement==='Pending'?'#F8A31F':item.agreement==='Initiated'?'#6E24E7':item.agreement==='Invalid'?'#F8A31F':'', 
                              textAlign:'center',borderRadius:'1em'}}>
                              {item.agreement?(item.agreement==="Pending"?<span><img src={pendingDot} alt=""/> Pending</span>:item.agreement==="Signed"?<span><img src={activeDot} alt=""/>{item.agreement}</span>:item.agreement==="Invalid"?<span><img src={pendingDot} alt=""/> Attn!</span>:item.agreement==="Not Initiated"?<span><img alt="" src={todoDot}/> To Do</span>:item.agreement==="Regenerated"?<span><img src={activeDot} alt=""/> Regen</span>:item.agreement==="Pending Coapplicant"?<span><img src={pendingDot} alt=""/> Co-app P</span>:item.agreement==='Manual'?<span><img src={activeDot} alt=""/>Manual</span>:item.agreement):"NA"}
                            </span>
                        </td>
                        {/* EMandate */}
                        <td style={{width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '8.9%': '8%', paddingLeft:'7px'}}>
                            <span id="emandate" onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" || decode.role === "exec") return; modalRef.current.open('mandate', {applicationId: item.applicationId, userId: item.userId, name: item.name, status: item.emandate, cra: item.cra, instituteName: item.instituteName})}}
                              style={{  padding: '3px 5px 3px 5px',
                              fontWeight:'600',textAlign:'center',borderRadius:'1em', fontSize: '12px',cursor:decode.role === "exec"? 'default': 'pointer',fontFamily:"Inter",whiteSpace:'nowrap', width: '6.5em',
                              color:`${item.emandate==='Upi Mandate Initiated'?'#6E24E7'
                                :item.emandate==='Aadhaar Mandate Initiated'?'#6E24E7'
                                :item.emandate==='Aadhaar Mandate Done'?'#12B76A'
                                :item.emandate==='Aadhaar Mandate Failed'?'#D22129'
                                :item.emandate==='Upi Mandate Failed'?'#D22129'
                                :item.emandate==='Upi Mandate Done'?'#12B76A'
                                :item.emandate==='Upi Mandate Partial'?'white'
                                :item.emandate==='Pass'?'#12B76A'
                                :item.emandate==='Emandate Auth Success'?'#F8A31F'
                                :item.emandate==='PhonePay Upi Initiated'?'#6E24E7'
                                :item.emandate==='PhonePay Upi Failed'?'#D22129'
                                :item.emandate==='PhonePay Upi Success'?'#12B76A'
                                :`${item.emandate==='Not Initiated'?'white'
                                  :item.emandate ==='Aadhaar Mandate ToDo'?"white"
                                  :item.emandate ==='Upi Mandate ToDo'?"white"
                                  :item.emandate ==='PhonePe Upi Mandate'?"white"
                                  :`${item.emandate==='Rejected'?'#D22129':`${item.emandate==='Partial'?'white':`${item.emandate==='Initiated'?'#6E24E7':`${item.emandate==='Invalid Bank Details'?'#F8A31F':''}`}`}`}`}`}`,
                              backgroundColor:`${item.emandate==='Upi Mandate Initiated'?'#EFE4FF':
                              item.emandate==='Upi Mandate Done'?'#ECFDF3':
                              item.emandate==='Pass'?'#ECFDF3':
                              item.emandate==='Upi Mandate Partial'?'#BA55D3':
                              item.emandate==='Aadhaar Mandate Initiated'?'#EFE4FF':
                              item.emandate==='Aadhaar Mandate Done'?'#ECFDF3':
                              item.emandate==='Aadhaar Mandate Failed'?'#FEEAEB':
                              item.emandate==='Aadhaar Mandate ToDo'?'#898989':
                              item.emandate==='Upi Mandate ToDo'?'#898989':
                              item.emandate==='Emandate Auth Success'?'#FFF6E8':
                              item.emandate==='PhonePay Upi Initiated'?'#EFE4FF':
                              item.emandate==='PhonePay Upi Failed'?'#FEEAEB':
                              item.emandate==='PhonePay Upi Success'?'#ECFDF3':
                              item.emandate==='PhonePe Upi Mandate'?'#898989':
                              `${item.emandate==='Not Initiated'?'#898989':
                              `${item.emandate==='Rejected'?'#FEEAEB':
                              `${item.emandate==='Partial'?'#BA55D3':
                              `${item.emandate==='Initiated'?'#EFE4FF':
                              `${item.emandate==='Invalid Bank Details'?'#FFF6E8':
                              `${item.emandate==='Not Applicable'?'#FFF':''}`}`}`}`}`}`}`}}>
                                
                              {item.emandate?
                              (item.emandate==="Rejected"?<span><img src={closedDot} alt=""/> Rejected</span>
                              :item.emandate==="Upi Mandate Failed"?<span title='Upi Mandate Failed'><img src={closedDot} alt=""/> Upi M</span>
                              :item.emandate==="Pass"?<span><img src={activeDot} alt=""/> Pass</span>
                              :item.emandate==="Upi Mandate Done"?<span title='Upi Mandate Done'><img src={activeDot} alt=""/> Upi M</span>
                              :item.emandate==="Initiated"?<span><img src={initiatedDot} alt=""/> Initiated</span>
                              :item.emandate==="Upi Mandate Initiated"?<span title='Upi Mandate Initiated'><img src={initiatedDot} alt=""/>Upi M</span>
                              :item.emandate==="Not Initiated"?<span><img src={todoDot} alt=""/> To Do</span>
                              :item.emandate==="Partial"?<span><img src={todoDot} alt=""/>Partial</span>
                              :item.emandate==="Upi Mandate Partial"?<span><img src={todoDot} alt=""/>Upi Partial</span>
                              :item.emandate==="Invalid Bank Details"?<span><img src={pendingDot} alt=""/>Attn! </span>
                              :item.emandate==="Emandate Auth Success"?<span><img src={pendingDot} alt=""/>Pending </span>
                              :item.emandate==="Aadhaar Mandate Initiated"?<span><img src={initiatedDot} alt=""/> A Initiated</span>
                              :item.emandate==="Aadhaar Mandate Done"?<span><img src={activeDot} alt=""/>A Pass</span>
                              :item.emandate==="Aadhaar Mandate Failed"?<span title='Aadhaar Mandate Failed'><img src={closedDot} alt=""/> A Fail</span>
                              :item.emandate==="Aadhaar Mandate ToDo"?<span><img src={todoDot} alt=""/>A To Do</span>
                              :item.emandate==="Upi Mandate ToDo"?<span><img src={todoDot} alt=""/>U To Do</span>
                              :item.emandate==="PhonePay Upi Initiated"?<span title='PhonePay Upi Initiated'><img src={initiatedDot} alt=""/> PP Initiated</span>
                              :item.emandate==="PhonePay Upi Failed"?<span title='PhonePay Upi Failed'><img src={closedDot} alt=""/> PP Failed</span>
                              :item.emandate==="PhonePay Upi Success"?<span title='PhonePay Upi Success'><img src={activeDot} alt=""/> PP Success</span>
                              :item.emandate==="PhonePe Upi Mandate"?<span title='PhonePe Upi Mandate'><img src={todoDot} alt=""/>PP To Do</span>
                              :item.emandate==="Not Applicable"?<span><img src={todoDot} alt=""/>NA</span>
                              :item.emandate):"NA"}
                            </span>
                        </td>
                        {/* Fraud */}
                        {decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"  || decode.role === "channel_user"?null:
                          <td style={{ display:'flex',justifyContent:'center', alignItems:'center', width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '4.5%': '4%',}}>
                          <span  onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" || decode.role === "exec") return; modalRef.current.open('fraud', {applicationId: item.applicationId, userId: item.userId, name: item.name})}} style={{cursor:decode.role === "exec"? 'default': 'pointer', }}>
                              {item.applicantFraudCheck?
                              (item.applicantFraudCheck==="fail"?<div title='fail' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                              :item.applicantFraudCheck==="pass"?<div title='pass' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                              :item.applicantFraudCheck):<div style={{fontSize:'12px',fontWeight:'bold'}}>NA</div>}
                            </span>
                      </td>  }
                      
                        <td style={{  color: '#667085',fontSize: '14px' ,fontFamily:"Inter", width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '11%': '8%', paddingLeft:'9px'}}>{item.amount ? ( <>&#8377;{formatNumberWithCommas(item.amount)}</>) : ( '-')}</td>
                        <td style={{  fontSize: '14px', paddingLeft:'7px', color: '#667085',fontFamily:"Inter" , width:'5%'}}>{item.tenure?item.tenure:'-'} </td>
                        {decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"  || decode.role === "channel_user" ? null :
                        <td style={{  color: '#667085',fontSize: '14px' ,fontFamily:"Inter", width:'3%',display:'flex', paddingLeft:'7px',  justifyContent:'center'}}>
                          {item?.paymentStatus ?
                          (
                            item?.paymentStatus === "Link Generated"?<div title='Link Generated' style={{fontSize:'12px',backgroundColor:'#F8A31F',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px', }}></div>
                            :item?.paymentStatus === "Failed"?<div title='Failed' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                            :item?.paymentStatus === "Paid"?<div title='Paid' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                            :item?.paymentStatus === "Not Applicable"?<div title='Not Applicable' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',fontWeight:'700',display:'flex',justifyContent:'center',alignItems:'center',color:'black'}}>NA</div>
                            :item?.paymentStatus === "Paid At Institute"?<div title='Paid At Institute' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',fontWeight:'700',display:'flex',justifyContent:'center',alignItems:'center',color:'black'}}>I</div>
                            :item?.paymentStatus
                          )
                          :"-"}
                         </td>}
                        { decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"  || decode.role === "channel_user" || decode.role === "exec"?null:
                            <td style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', width:'6em', }}>
                          <span title="Edit form"><EditForm curruser={item}/></span>
                            <span title='Move Status'><MoveSanctionStatus    ApplicantId={item} coapplicants={item.coapplicants}  /></span>
                            {decode.role === "admin" || decode.role === "crsa" || decode.role === "crm" || decode.role === "institute_cra" ? 
                            <>
                             <span title="Payment Link">
                              {item.paymentStatus ? (       
                                <img src={utr} style={{ height: '20px', marginLeft: '4px', cursor: 'not-allowed' }} alt=""/>
                              ) : (
                              <img
                                src={utr} alt=""
                                style={{ 
                                  height: '20px', 
                                  marginLeft: '7px', 
                                  cursor: item.instituteName === 'NxtWave' ? 'not-allowed' : 'pointer' 
                                }}
                                onClick={item.instituteName === 'NxtWave' ? null : () => togglePayment(item)}
                              />
                              )}
                            </span> 
                            </>
                            :
                            <></>}
                        </td>}

                        </CustomAccordionSummary>
                        {
                          item?.coapplicants?.map((coapp, index) => (
                          <CustomAccordionSummary sx={{ width: '100%', margin: 0, padding: 0 }} key={index}>
                        
                          {/* Appl. Id */}
                          <td className='application-id'  style={{width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '13.3%':'12%',}}>
                          </td>
                          {/* Appl. Name */}
                          <td title={coapp.coapplicantName} className='application-id'  style={{width:'15%',cursor:'pointer',color:'#667085'  }} onClick={() => {if(decode.role==="institute_user"||decode.role==="institute_admin"|| decode.role === "channel_user") return 
                            handleCoApp(item, coapp?.coapplicantId)}}>{coapp?.coapplicantName?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} (C)</td>
                          {(decode.role==="institute_user"||decode.role==="institute_admin"  || decode.role === "channel_user")&&decode.instituteId === "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" &&
                           <td title={item.studentName} lassName='application-id'></td>
                           }
                           {/* MerchantName */}
                          <td title={item.instituteName} style={{width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '15.5%':'14%'}}  >
                           
                          </td>
                          {/* Digilocker */}
                        
                          <td style={{ width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '8.9%':'8%', paddingLeft:'7px'}}  >
                            <span  id="selfie" onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin"|| decode.role === "channel_user" || decode.role === "exec") return; modalRef.current.open('digilocker', {applicationId: item.applicationId, userId: coapp.coapplicantId, name: coapp.coapplicantName, status: coapp.coapplicantDigilockerStatus})}}
                                style={{ cursor:decode.role === "exec"? 'default': 'pointer', fontWeight:'600',fontSize: '12px', padding: '3px 5px 3px 5px',
                                backgroundColor:`${coapp.coapplicantDigilockerStatus==='Pass'?'#ECFDF3':`${coapp.coapplicantDigilockerStatus==='Not Initiated'?'#898989':`${coapp.coapplicantDigilockerStatus==='Failed'?'#FEEAEB':`${coapp.coapplicantDigilockerStatus==='Initiated'?'#EFE4FF':`${coapp.coapplicantDigilockerStatus==='Alert'?"#FFF6E8":''}`}`}`}`}`,
                                color:`${coapp.coapplicantDigilockerStatus==='Pass'?'#12B76A':`${coapp.coapplicantDigilockerStatus==='Not Initiated'?'white':`${coapp.coapplicantDigilockerStatus==='Failed'?'red':`${coapp.coapplicantDigilockerStatus==='Initiated'?'#6E24E7':`${coapp.coapplicantDigilockerStatus==='Alert'?"#F8A31F":''}`}`}`}`}`,
                                  textAlign:'center',borderRadius:'1em'}}> 
                                {coapp.coapplicantDigilockerStatus?(coapp.coapplicantDigilockerStatus==="Pass"?<span><img src={activeDot} alt=""/> Pass</span>:coapp.coapplicantDigilockerStatus==="Failed"?<span><img src={closedDot} alt=""/> Failed</span>:coapp.coapplicantDigilockerStatus==="Not Initiated"?<span><img src={todoDot} alt=""/> To Do</span>:coapp.coapplicantDigilockerStatus==="Initiated"?<span><img src={initiatedDot} alt=""/> Initiated</span>:coapp.coapplicantDigilockerStatus==="Alert"?<span><img src={pendingDot} alt=""/> Attn!</span>:coapp.coapplicantDigilockerStatus):"NA"}
            
                            </span>
                          </td>
                          {/* Selfie */}
                          <td style={{ width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '8.9%':'8%', paddingLeft:'7px'}}  >
                            <span   id="selfie" onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin"|| decode.role === "channel_user" || decode.role === "exec") return; modalRef.current.open('selfie', {applicationId: item.applicationId, userId: coapp.coapplicantId, name: coapp.coapplicantName})}}
                                style={{ cursor:decode.role === "exec"? 'default': 'pointer', fontWeight:'600',fontSize: '12px', padding: '3px 5px 3px 5px',
                                backgroundColor:`${coapp.coapplicantSelfie==='Pass'?'#ECFDF3':`${coapp.coapplicantSelfie==='Not Initiated'?'#898989':`${coapp.coapplicantSelfie==='Failed'?'#FEEAEB':`${coapp.coapplicantSelfie==='Initiated'?'#EFE4FF':`${coapp.coapplicantSelfie==='Face mismatch'?"#FFF6E8":''}`}`}`}`}`,
                                color:`${coapp.coapplicantSelfie==='Pass'?'#12B76A':`${coapp.coapplicantSelfie==='Not Initiated'?'white':`${coapp.coapplicantSelfie==='Failed'?'red':`${coapp.coapplicantSelfie==='Initiated'?'#6E24E7':`${coapp.coapplicantSelfie==='Face mismatch'?"#F8A31F":''}`}`}`}`}`,
                                  textAlign:'center',borderRadius:'1em'}}> 
                                {coapp.coapplicantSelfie?(coapp.coapplicantSelfie==="Pass"?<span><img src={activeDot} alt=""/> Pass</span>:coapp.coapplicantSelfie==="Failed"?<span><img src={closedDot} alt=""/> Failed</span>:coapp.coapplicantSelfie==="Not Initiated"?<span><img src={todoDot} alt=""/> To Do</span>:coapp.coapplicantSelfie==="Initiated"?<span><img src={initiatedDot} alt=""/> Initiated</span>:coapp.coapplicantSelfie==="Face mismatch"?<span><img src={pendingDot} alt=""/> Attn!</span>:coapp.coapplicantSelfie):"NA"}
            
                            </span>
                          </td>
                          
                          {/* Aggrement */}
                          <td style={{  width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '8.9%':'8%', paddingLeft:'7px'}}  >
                            <span onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" || decode.role === "exec") return; modalRef.current.open('agreement', {applicationId: item.applicationId, userId: coapp.coapplicantId, name: coapp.coapplicantName, status: coapp.coapplicantAgreement})}}id="signed"
                              style={{cursor:decode.role === "exec"? 'default': 'pointer',fontSize: '12px',  fontFamily:"Inter",fontWeight:'600',  padding: '3px 5px 3px 5px',
                                backgroundColor:coapp.coapplicantAgreement==='Signed'||coapp.coapplicantAgreement==='Manual'?'#ECFDF3':coapp.coapplicantAgreement==="Regenerated"?'#00AD83':coapp.coapplicantAgreement==='Not Initiated'?'#898989':coapp.coapplicantAgreement==='Pending'?'#FFF6E8':coapp.coapplicantAgreement==='Initiated'?'#EFE4FF':coapp.coapplicantAgreement==='Invalid'?'#FFF6E8':coapp.coapplicantAgreement==="Pending Coapplicant"?"#FFF6E8":'',textDecoration:coapp.coapplicantAgreement==='Signed'||coapp.coapplicantAgreement==='Manual'?'underline':'none',
                                color:coapp.coapplicantAgreement==='Signed'||coapp.coapplicantAgreement==='Manual'?'#12B76A':coapp.coapplicantAgreement==="Regenerated"?'white':coapp.coapplicantAgreement==="Pending Coapplicant"?'#F8A31F':coapp.coapplicantAgreement==='Not Initiated'?'white':coapp.coapplicantAgreement==='Pending'?'#F8A31F':coapp.coapplicantAgreement==='Initiated'?'#6E24E7':coapp.coapplicantAgreement==='Invalid'?'#F8A31F':'', 
                              textAlign:'center',borderRadius:'1em'}}>
                              {coapp.coapplicantAgreement?(coapp.coapplicantAgreement==="Pending"?<span><img src={pendingDot} alt=""/> Pending</span>:coapp.coapplicantAgreement==="Signed"?<span><img src={activeDot} alt=""/>{coapp.coapplicantAgreement}</span>:coapp.coapplicantAgreement==="Invalid"?<span><img src={pendingDot} alt=""/> Attn!</span>:coapp.coapplicantAgreement==="Not Initiated"?<span><img src={todoDot} alt=""/> To Do</span>:coapp.coapplicantAgreement==="Regenerated"?<span><img src={activeDot} alt=""/> Regen</span>:coapp.coapplicantAgreement==="Pending Coapplicant"?<span><img src={pendingDot} alt=""/> Co-app P</span>:coapp.coapplicantAgreement==='Manual'?<span><img src={activeDot} alt=""/>Manual</span>:coapp.coapplicantAgreement):"NA"}
                            </span>
                        </td>
                        {/* EMandate */}
                        <td  style={{width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '8.9%':'8%', paddingLeft:'7px', }}>
                            <span id="emandate"  onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" || decode.role === "exec") return; modalRef.current.open('mandate', {applicationId: item.applicationId, userId: coapp.coapplicantId, name: coapp.coapplicantName, status: coapp.coapplicantEmandate, cra: item.cra, instituteName: item.instituteName})}} style={{  padding: '3px 5px 3px 5px',
                              fontWeight:'600', color:coapp.coapplicantEmandate==='Invalid Bank Details'?'#A50021':coapp.coapplicantEmandate==='Not Applicable'?'#000':'white',textAlign:'center',borderRadius:'1em', fontSize: '12px',cursor:decode.role === "exec"? 'default': 'pointer',fontFamily:"Inter",whiteSpace:'nowrap', width: '6.5em',
                              color:`${coapp.coapplicantEmandate==='Upi Mandate Initiated'?'#6E24E7'
                                :coapp.coapplicantEmandate==='Aadhaar Mandate Initiated'?'#6E24E7'
                                :coapp.coapplicantEmandate==='Aadhaar Mandate Done'?'#12B76A'
                                :coapp.coapplicantEmandate==='Aadhaar Mandate Failed'?'#D22129'
                                :coapp.coapplicantEmandate==='Upi Mandate Failed'?'#D22129'
                                :coapp.coapplicantEmandate ==='Aadhaar Mandate ToDo'?"white"
                                  :coapp.coapplicantEmandate ==='Upi Mandate ToDo'?"white"
                                  :coapp.coapplicantEmandate==='Emandate Auth Success'?'#F8A31F'
                                :coapp.coapplicantEmandate==='Upi Mandate Done'?'#12B76A':coapp.coapplicantEmandate==='Upi Mandate Partial'?'white':coapp.coapplicantEmandate==='Pass'?'#12B76A':`${coapp.coapplicantEmandate==='Not Initiated'?'white':`${coapp.coapplicantEmandate==='Rejected'?'#D22129':`${coapp.coapplicantEmandate==='Partial'?'white':`${coapp.coapplicantEmandate==='Initiated'?'#6E24E7':`${coapp.coapplicantEmandate==='Invalid Bank Details'?'#F8A31F':''}`}`}`}`}`}`,
                              backgroundColor:`${coapp.coapplicantEmandate==='Upi Mandate Initiated'?'#EFE4FF'
                              :coapp.coapplicantEmandate==='Upi Mandate Done'?'#ECFDF3'
                              :coapp.coapplicantEmandate==='Pass'?'#ECFDF3'
                              :coapp.coapplicantEmandate==='Upi Mandate Partial'?'#BA55D3':
                              coapp.coapplicantEmandate==='Aadhaar Mandate Initiated'?'#EFE4FF':
                              coapp.coapplicantEmandate==='Aadhaar Mandate Done'?'#ECFDF3':
                              coapp.coapplicantEmandate==='Aadhaar Mandate Failed'?'#FEEAEB':
                              coapp.coapplicantEmandate==='Aadhaar Mandate ToDo'?'#898989':
                              coapp.coapplicantEmandate==='Upi Mandate ToDo'?'#898989':coapp.coapplicantEmandate==='Emandate Auth Success'?'#FFF6E8'
                              :`${coapp.coapplicantEmandate==='Not Initiated'?'#898989':`${coapp.coapplicantEmandate==='Rejected'?'#FEEAEB':`${coapp.coapplicantEmandate==='Partial'?'#BA55D3':`${coapp.coapplicantEmandate==='Initiated'?'#EFE4FF':`${coapp.coapplicantEmandate==='Invalid Bank Details'?'#FFF6E8':`${coapp.coapplicantEmandate==='Not Applicable'?'#FFF':''}`}`}`}`}`}`}`}}>
                                
                              {coapp.coapplicantEmandate?
                              (coapp.coapplicantEmandate==="Rejected"?<span><img src={closedDot} alt=""/> Rejected</span>
                              :coapp.coapplicantEmandate==="Upi Mandate Failed"?<span title='Upi Mandate Failed'><img src={closedDot} alt=""/> Upi M</span>
                              :coapp.coapplicantEmandate==="Pass"?<span><img src={activeDot} alt=""/> Pass</span>
                              :coapp.coapplicantEmandate==="Upi Mandate Done"?<span title='Upi Mandate Done'><img src={activeDot} alt=""/> Upi M</span>
                              :coapp.coapplicantEmandate==="Initiated"?<span><img src={initiatedDot} alt=""/> Initiated</span>
                              :coapp.coapplicantEmandate==="Upi Mandate Initiated"?<span title='Upi Mandate Initiated'><img src={initiatedDot} alt=""/>Upi M</span>
                              :coapp.coapplicantEmandate==="Not Initiated"?<span><img src={todoDot} alt=""/> To Do</span>
                              :coapp.coapplicantEmandate==="Partial"?<span><img src={todoDot} alt=""/>Partial</span>
                              :coapp.coapplicantEmandate==="Upi Mandate Partial"?<span><img src={todoDot} alt=""/>Upi Partial</span>
                              :coapp.coapplicantEmandate==="Invalid Bank Details"?<span><img src={pendingDot} alt=""/>Attn! </span>
                              :coapp.coapplicantEmandate==="Emandate Auth Success"?<span><img src={pendingDot} alt=""/>Pending </span>
                              :coapp.coapplicantEmandate==="Aadhaar Mandate Initiated"?<span><img src={initiatedDot} alt=""/> A Initiated</span>
                              :coapp.coapplicantEmandate==="Aadhaar Mandate Done"?<span><img src={activeDot} alt=""/>A Pass</span>
                              :coapp.coapplicantEmandate==="Aadhaar Mandate Failed"?<span title='Aadhaar Mandate Failed'><img src={closedDot} alt=""/> A Fail</span>
                              :coapp.coapplicantEmandate==="Aadhaar Mandate ToDo"?<span><img src={todoDot} alt=""/>A To Do</span>
                              :coapp.coapplicantEmandate==="Upi Mandate ToDo"?<span><img src={todoDot} alt=""/>U To Do</span>
                              :coapp.coapplicantEmandate==="Not Applicable"?<span><img src={todoDot} alt=""/>NA</span>
                              :coapp.coapplicantEmandate):"NA"}
                            </span>
                        </td>
                        {/* Fraud */}
                        <td style={{  display:'flex', width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '4.5%':'4%', justifyContent:'center', alignItems:'center',   }}>
                            <span  onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" || decode.role === "exec") return; modalRef.current.open('fraud', {applicationId: item.applicationId, userId: coapp.coapplicantId, name: coapp.coapplicantName})}} style={{cursor:decode.role === "exec"? 'default': 'pointer',  }}>
                                {coapp.coapplicantFraudCheck?
                                (coapp.coapplicantFraudCheck==="fail"?<div title='fail' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                :coapp.coapplicantFraudCheck==="pass"?<div title='pass' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                :coapp.coapplicantFraudCheck):<div  style={{fontSize:'12px',fontWeight:'bold'}}>NA</div>}
                              </span>
                        </td>  
                        <td style={{  color: '#667085',fontSize: '14px' ,fontFamily:"Inter", width:'8%', paddingLeft:'9px'}}></td>
                        <td style={{  fontSize: '14px', paddingLeft:'7px', color: '#667085',fontFamily:"Inter" , width:'5%'}}> </td>
                        {decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender" || decode.role === "channel_user" ? null :
                        <td style={{ color: '#667085',fontSize: '14px' ,fontFamily:"Inter", width:'3%',display:'flex',justifyContent:'center', paddingLeft:'7px',  }}>
                          {coapp?.paymentStatus ?
                          (
                            coapp?.paymentStatus === "Link Generated"?<div title='Link Generated' style={{fontSize:'12px',backgroundColor:'#F8A31F',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px', }}></div>
                            :coapp?.paymentStatus === "Failed"?<div title='Failed' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                            :coapp?.paymentStatus === "Paid"?<div title='Paid' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                            :coapp?.paymentStatus === "Not Applicable"?<div title='Not Applicable' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',fontWeight:'700',display:'flex',justifyContent:'center',alignItems:'center',color:'black'}}>NA</div>
                            :coapp?.paymentStatus === "Paid At Institute"?<div title='Paid At Institute' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',fontWeight:'700',display:'flex',justifyContent:'center',alignItems:'center',color:'black'}}>I</div>
                            :coapp?.paymentStatus
                          )
                          :"-"}
                         </td>}
                        { decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"  || decode.role === "channel_user"?null:
                        <td style={{  display:'flex', justifyContent:'center',width:'4em', }}>
                           
                        </td>}

                        </CustomAccordionSummary>
                            )
                          )
                        }
                        
                      </CustomAccordion>
                    </td>
                  </tr>
                );
              })}
            </tbody>

            </table>
            </div>
            {totalFetchRows ? ( totalFetchRows <= 100 ?(
                    <div style={{display:"flex" ,justifyContent:"center",marginTop:"10px"}}>
                      <div style={{ textAlign: 'center', fontWeight: 'bold',fontFamily:"Inter", fontSize: '1vw',marginLeft:'10px',marginBottom:'5px' }}>
               
               Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage - rowsPerPage+tableData?.length}{" "}
                records of {totalFetchRows} |
               
             </div>
            <div style={{display:"flex", justifyContent:"space-between",}}>
            &nbsp;<p style={{fontWeight:'600'}}>Rows Per Pages :</p>
          <div>
          <span onClick={()=>handlepageChange(15)} style={{cursor:'pointer',padding:'10px',color: activePage === 15 ? "#D32028" : "black",backgroundColor:activePage === 15 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>15</span>
          <span onClick={()=>handlepageChange(50)} style={{cursor:'pointer',padding:'10px',color: activePage === 50 ? "#D32028" : "black",backgroundColor:activePage === 50 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>50</span>
          <span onClick={()=>handlepageChange(100)} style={{cursor:'pointer',padding:'10px',color: activePage === 100 ? "#D32028" : "black",backgroundColor:activePage === 100 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>100</span>
          <span onClick={()=>handlepageChange(500)} style={{cursor:'pointer',padding:'10px',color: activePage === 500 ? "#D32028" : "black",backgroundColor:activePage === 500 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>500</span>
          </div>
         
         
          </div>
                      
                    </div>
               
            ):( <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}><div style={{ textAlign: 'center',fontWeight: 'bold',justifyContent:"space-between",fontFamily:"Inter-Medium", fontSize: '1vw',marginLeft:'10px',marginBottom:'5px',marginRight:'10px'}}>
                
            Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage - rowsPerPage+tableData?.length} {" "}
            records of {totalFetchRows} |
           
          </div>
          <div style={{display:"flex", justifyContent:"space-between",}}>
            <p style={{fontWeight:'600'}}>Rows Per Pages :</p>
          <div>
          <span onClick={()=>handlepageChange(15)} style={{cursor:'pointer',padding:'10px',color: activePage === 15 ? "#D32028" : "black",backgroundColor:activePage === 15 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>15</span>
          <span onClick={()=>handlepageChange(50)} style={{cursor:'pointer',padding:'10px',color: activePage === 50 ? "#D32028" : "black",backgroundColor:activePage === 50 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>50</span>
          <span onClick={()=>handlepageChange(100)} style={{cursor:'pointer',padding:'10px',color: activePage === 100 ? "#D32028" : "black",backgroundColor:activePage === 100 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>100</span>
          <span onClick={()=>handlepageChange(500)} style={{cursor:'pointer',padding:'10px',color: activePage === 500 ? "#D32028" : "black",backgroundColor:activePage === 500 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>500</span>
          </div>
          </div>
          </div> )
             
            ) : (
              <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily:"Inter", fontSize: '14px' }}>No Records</div>
            )}

            <PaginationTable
              startPage={currentPage}
              rowsPerPage={rowsPerPage}
              totalRows={totalFetchRows}
              paginate={paginate}
              filterDateFrom={filterDateFrom}
            />

          </>
        )}
        <IntegrationModals ref={modalRef} user={user} decode={decode} onActionComplete={refreshTableData} />
        </CardBody>

      </Card>
    );
  }
  return <div>....Loading</div>;
};

export default SanctionTable;
